// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/CheckBox.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(//fonts.googleapis.com/earlyaccess/notosanskr.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";

.notosanskr * { 
 font-family: 'Noto Sans KR', sans-serif;
}

/*reset*/
body, div, header, footer, aside, section, article, nav, ul, li, ol, dl, dt,
h1, h2, h3, h4, h5, h6, p,
table, tr, td, th, caption, thead, tfoot, tbody,
form, fieldset,
figure, figcaption, address,
input, button, select, option{margin: 0; padding:0;}
ul{list-style: none;}
a{text-decoration: none; color: #222;}
img{border: 0; vertical-align: top; max-width: 100%;}
html, body{min-height: 100%;/*반응형*/overflow-x: hidden;}

body{font-family: 'Noto Sans KR', sans-serif;font-size: 14px;color: #222;letter-spacing: -0.04em;
/* background: linear-gradient(142deg, #96E9F4 0%, #D8D2FC 0%, #C6E3FF 0.01%, #8DE0D6 28.35%, #B1E0EA 74.48%, #8AFFF8 100%, rgba(215, 255, 255, 0.00) 100%); */
background:#f2f2f2;
padding: 20px 30px; min-width: 1500px;height: 100vh; box-sizing: border-box;}

/* drag 방지 */
body {
  -webkit-user-select:none;
  user-select:none
}

*:focus {
    outline: none;
}

input, button, select, option, textarea{
    appearance: none;
    border-radius: none;
    box-sizing:border-box;
}
/* Forms
   ========================================================================== */

/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */

button,
input,
option,
select{
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
  padding: 0;
  
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */

button,
input { /* 1 */
  overflow: hidden;
    border: 0;
    font-size: 18px;
    color:#333435;
}

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */

button,
select { /* 1 */
  text-transform: none;
    border: 0;
    font-size: 18px;
    color:#333435;
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
  -moz-appearance: button;
    background: none;
}

/**
 * Remove the inner border and padding in Firefox.
 */

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

input[type="text"]{font-size: 14px; background: none;}
input[type="checkbox"]{
    width: 20px;
    height: 20px;
    border: 1px solid #AEAEB2;
    border-radius: 4px;
    box-sizing: border-box;
}
input[type="checkbox"]:checked {
     border: none;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
}

input[type="radio"] {

}
input[type="radio"]:checked {
  
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox  */
input[type='number'] {
  -moz-appearance: textfield;
}`, "",{"version":3,"sources":["webpack://./src/css/reset.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAGhB;CACC,uCAAuC;AACxC;;AAEA,QAAQ;AACR;;;;;8BAK8B,SAAS,EAAE,SAAS,CAAC;AACnD,GAAG,gBAAgB,CAAC;AACpB,EAAE,qBAAqB,EAAE,WAAW,CAAC;AACrC,IAAI,SAAS,EAAE,mBAAmB,EAAE,eAAe,CAAC;AACpD,WAAW,gBAAgB,CAAC,MAAM,CAAC,kBAAkB,CAAC;;AAEtD,KAAK,uCAAuC,CAAC,eAAe,CAAC,WAAW,CAAC,uBAAuB;AAChG,8JAA8J;AAC9J,kBAAkB;AAClB,kBAAkB,EAAE,iBAAiB,CAAC,aAAa,EAAE,sBAAsB,CAAC;;AAE5E,YAAY;AACZ;EACE,wBAAwB;EAGxB;AACF;;AAEA;IACI,aAAa;AACjB;;AAEA;IAGI,gBAAgB;IAKhB,mBAAmB;IACnB,qBAAqB;AACzB;AACA;+EAC+E;;AAE/E;;;EAGE;;AAEF;;;;EAIE,oBAAoB,EAAE,MAAM;EAC5B,eAAe,EAAE,MAAM;EACvB,iBAAiB,EAAE,MAAM;EACzB,SAAS,EAAE,MAAM;EACjB,UAAU;;AAEZ;;AAEA;;;EAGE;;AAEF;QACQ,MAAM;EACZ,gBAAgB;IACd,SAAS;IACT,eAAe;IACf,aAAa;AACjB;;AAEA;;;EAGE;;AAEF;SACS,MAAM;EACb,oBAAoB;IAClB,SAAS;IACT,eAAe;IACf,aAAa;AACjB;;AAEA;;EAEE;;AAEF;;;;EAIE,0BAA0B;EAC1B,uBAAuB;IACrB,gBAAgB;AACpB;;AAEA;;EAEE;;AAEF;;;;EAIE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE;;AAEF;;;;EAIE,8BAA8B;AAChC;;AAEA,mBAAmB,eAAe,EAAE,gBAAgB,CAAC;AACrD;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;KACK,YAAY;IACb,mDAAoC;IACpC,wBAAwB;AAC5B;;AAEA;;AAEA;AACA;;AAEA;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,aAAa;AACb;EACE,0BAA0B;AAC5B","sourcesContent":["@charset \"utf-8\";\n@import url(//fonts.googleapis.com/earlyaccess/notosanskr.css);\n\n.notosanskr * { \n font-family: 'Noto Sans KR', sans-serif;\n}\n\n/*reset*/\nbody, div, header, footer, aside, section, article, nav, ul, li, ol, dl, dt,\nh1, h2, h3, h4, h5, h6, p,\ntable, tr, td, th, caption, thead, tfoot, tbody,\nform, fieldset,\nfigure, figcaption, address,\ninput, button, select, option{margin: 0; padding:0;}\nul{list-style: none;}\na{text-decoration: none; color: #222;}\nimg{border: 0; vertical-align: top; max-width: 100%;}\nhtml, body{min-height: 100%;/*반응형*/overflow-x: hidden;}\n\nbody{font-family: 'Noto Sans KR', sans-serif;font-size: 14px;color: #222;letter-spacing: -0.04em;\n/* background: linear-gradient(142deg, #96E9F4 0%, #D8D2FC 0%, #C6E3FF 0.01%, #8DE0D6 28.35%, #B1E0EA 74.48%, #8AFFF8 100%, rgba(215, 255, 255, 0.00) 100%); */\nbackground:#f2f2f2;\npadding: 20px 30px; min-width: 1500px;height: 100vh; box-sizing: border-box;}\n\n/* drag 방지 */\nbody {\n  -webkit-user-select:none;\n  -moz-user-select:none;\n  -ms-user-select:none;\n  user-select:none\n}\n\n*:focus {\n    outline: none;\n}\n\ninput, button, select, option, textarea{\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    -webkit-border-radius: none;\n    -moz-border-radius: none;\n    -ms-border-radius: none;\n    -o-border-radius: none;\n    border-radius: none;\n    box-sizing:border-box;\n}\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change the font styles in all browsers.\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noption,\nselect{\n  font-family: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n  padding: 0;\n  \n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput { /* 1 */\n  overflow: hidden;\n    border: 0;\n    font-size: 18px;\n    color:#333435;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect { /* 1 */\n  text-transform: none;\n    border: 0;\n    font-size: 18px;\n    color:#333435;\n}\n\n/**\n * Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n  -moz-appearance: button;\n    background: none;\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\ninput[type=\"text\"]{font-size: 14px; background: none;}\ninput[type=\"checkbox\"]{\n    width: 20px;\n    height: 20px;\n    border: 1px solid #AEAEB2;\n    border-radius: 4px;\n    box-sizing: border-box;\n}\ninput[type=\"checkbox\"]:checked {\n     border: none;\n    background: url(../img/CheckBox.png);\n    background-size: contain;\n}\n\ninput[type=\"radio\"] {\n\n}\ninput[type=\"radio\"]:checked {\n  \n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox  */\ninput[type='number'] {\n  -moz-appearance: textfield;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
